import compact from 'lodash/compact';
import sumBy from 'lodash/sumBy';
import moment from 'moment';
import { instBundle } from '@/axios.js';
import util from '@/util.js';
import filter from '@/filters.js';

const axiosAdmin2 = instBundle.axiosAdmin2;
const axiosAdmin2NoSpinner = instBundle.axiosAdmin2NoSpinner;

const orderList = [
	{ value: 1, name: '최근출석순' },
	{ value: 2, name: '이전출석순' },
	{ value: 3, name: '출석많은순' },
	{ value: 4, name: '출석적은순' },
	{ value: 5, name: '댓글많은순' },
	{ value: 6, name: '댓글적은순' },
];

export default {
	namespaced: true,
	state: {
		hasNew: true,
		id: null,
		details: null,
		conditionList: [],
		participantList: [],
		targetGroupList: [],
		targetGroup: null,
		lastParticipantListReqUrl: '',
		targetGroupWinnerList: [],
		winnerGroupList: [],
		currTabWinnerList: [],
		randomCnt: '',
		groupTab: null,
		orderList,
		winnerListOrder: orderList[0].value,
	},
	getters: {
		nextMonth() {
			return moment().add(1, 'month').format('YYYY-MM');
		},
		winnerCheckedParticipantList(state) {
			return state.participantList.map(item => ({
				...item,
				winner:
					!!state.details.select_on ||
					state.targetGroupWinnerList.some(
						winner => winner.idRegister === item.idRegister
					),
			}));
		},
		parseRegisterList: (state, getters, rootState, rootGetters) => list =>
			list.map(item => ({
				...item,
				genderName: rootGetters.getItemById('gender', item.gender)
					?.name,
				gradeName: rootGetters.getItemById('grade', item.grade)?.name,
				gradeColor: rootGetters.getItemById('grade', item.grade)?.color,
				phone: filter.phone(item.userTel),
				addr: compact([item.userAddress, item.userAddressMore]).join(
					' '
				),
				totalWinnerCnt: item.event_winner_cnt + item.stamp_winner_cnt,
			})),
		leftWinnerCnt(state) {
			const condition = state.conditionList.find(
				item => item.id === state.targetGroup
			);
			return condition
				? condition.sum_winner -
						(state.winnerGroupList.find(
							item => item.stamp_condition_id === condition.id
						)?.total_count || 0)
				: null;
		},
		getWinnerCount: state => id =>
			state.winnerGroupList.find(item => item.stamp_condition_id === id)
				?.total_count || 0,
		groupTabList(state, getters) {
			const getWinnerCount = getters.getWinnerCount;
			const conditionList = state.conditionList;
			return [
				{
					id: null,
					value: `전체 - ${getWinnerCount(null)}/${sumBy(conditionList, 'sum_winner')}명`,
				},
				...conditionList.map(item => ({
					id: item.id,
					value: `${item.title} - ${getWinnerCount(item.id)}/${item.sum_winner}명`,
				})),
			];
		},
	},
	mutations: {
		init(state) {
			state.hasNew = true;
			state.id = null;
			state.details = null;
			state.conditionList = [];
			state.participantList = [];
			state.targetGroupList = [];
			state.targetGroup = null;
			state.lastParticipantListReqUrl = '';
			state.targetGroupWinnerList = [];
			state.winnerGroupList = [];
			state.currTabWinnerList = [];
			state.randomCnt = '';
			state.groupTab = null;
			state.winnerListOrder = state.orderList[0].value;
		},
		changeState(state, list) {
			list.forEach(({ key, value }) => {
				if (state.hasOwnProperty(key)) {
					state[key] = value;
				}
			});
		},
	},
	actions: {
		async setHasNew({ getters, state }) {
			const {
				data: { stamps },
			} = await axiosAdmin2.get('/v3/api/stamp', {
				params: {
					offset: 0,
					limit: 10,
					order: 1,
				},
			});
			if (
				stamps.every(
					item =>
						moment(item.start_on).format('YYYY-MM') !==
						getters.nextMonth
				)
			) {
				state.hasNew = false;
			}
		},
		async setDetails({ state }, id) {
			try {
				const { data } = await axiosAdmin2NoSpinner.get(
					`/v3/api/stamp/${id}`
				);
				state.details = data.stamp;
				state.conditionList = data.stamp_condition_list;
				state.targetGroupList = data.stamp_condition_list.map(item => ({
					value: item.id,
					name: item.title,
				}));
				state.targetGroup = data.stamp_condition_list[0].id;
				return data.stamp.message;
			} catch (err) {
				console.error(err);
				alert('출석체크 정보를 불러오는데 실패했습니다.');
			}
		},
		async setParticipantList({ state, getters }, params) {
			try {
				const {
					data: { stamp_register_list },
					config: { url },
				} = await axiosAdmin2NoSpinner.get(
					`/v3/api/stamp/${state.id}/search`,
					{ params }
				);
				state.participantList =
					getters.parseRegisterList(stamp_register_list);
				state.lastParticipantListReqUrl = url;
			} catch (e) {
				console.error(e);
				alert('당첨 조건 대상 검색 실패!');
			}
		},
		async setTargetGroupWinnerList({ state, getters }) {
			try {
				const stampConditionId = state.targetGroup;
				if (stampConditionId) {
					const params = { stampConditionId };
					const { data } = await axiosAdmin2NoSpinner.get(
						`/v3/api/stamp/${state.id}/winner`,
						{ params }
					);
					state.targetGroupWinnerList = getters.parseRegisterList(
						data.stamp_winner_info[0].winners
					);
					state.winnerGroupList = data.stamp_winner_groups;
					state.randomCnt = getters.leftWinnerCnt;
				}
			} catch (e) {
				console.error(e);
				alert('선택된 당첨그룹명의 당첨자 로드 실패!');
			}
		},
		csvDown({ state }, isWinner) {
			const headers = [
				'회원번호',
				'닉네임',
				'성별',
				'나이',
				'회원등급',
				'출석누적',
				'일반출석',
				'리뷰미션',
				'댓글',
				'이름',
				'휴대폰',
				'주소',
				'당첨이력',
			];
			const rows = (
				isWinner ? state.currTabWinnerList : state.participantList
			).map(item => [
				item.idRegister,
				item.nickName,
				item.genderName,
				item.age,
				item.gradeName,
				item.stamp_all_cnt,
				item.stamp_normal_cnt,
				item.stamp_review_cnt,
				item.comment_cnt,
				item.userName,
				`=\"${item.userTel}\"`,
				item.addr,
				item.totalWinnerCnt,
			]);
			util.getCsv(
				[rows],
				undefined,
				[headers],
				`글로우픽_출석체크${isWinner ? '당첨자' : '참여자'}_${Date.now()}`,
				state.lastParticipantListReqUrl
			);
		},
		async setWinnerList({ state, getters }) {
			try {
				const params = {
					order: state.winnerListOrder,
					stampConditionId: state.groupTab,
				};
				const { data } = await axiosAdmin2NoSpinner.get(
					`/v3/api/stamp/${state.id}/winner`,
					{ params }
				);
				state.currTabWinnerList = getters.parseRegisterList(
					data.stamp_winner_info[0].winners
				);
			} catch (e) {
				console.error(e);
				alert('당첨자 로드 실패!');
			}
		},
	},
};
